import type { ResolvedInstance } from '@/types/Instance';

export const applyInstanceToBody = (
  body: HTMLElement,
  instance: ResolvedInstance,
  previousSlug?: string
): string => {
  if (previousSlug) {
    body.classList.remove(`instance-${previousSlug}`);
  }

  for (const className of Array.from(body.classList)) {
    if (className.startsWith('instance-')) {
      body.classList.remove(className);
    }
  }

  body.classList.add(`instance-${instance.slug}`);

  if (instance.brand.accentColor) {
    body.style.setProperty('--instance-accent', instance.brand.accentColor);
  } else {
    body.style.removeProperty('--instance-accent');
  }

  return instance.slug;
};
